import * as yup from 'yup'
import { TYPE_REQUIRED } from 'constants/errors'
import { routingNumberSchema, accountNumberSchema, bankAccountTypeSchema } from 'helpers/schemaHelpers'

type AmountStepFields = {
  amount: number
}

type AccountStepFields = {
  bank_account_type: string
  routing_number: string
  account_number: string
  remember?: boolean
  name?: string
}

type ConfirmationStepFields =
  & AmountStepFields
  & AccountStepFields

const amountStep = {
  amount: yup.number().required(TYPE_REQUIRED),
}
export const amountStepSchema =
  yup.object().shape(amountStep as unknown as Record<string, yup.Schema<unknown>>) as unknown as yup.ObjectSchema<AmountStepFields>

const accountStep = {
  bank_account_type: bankAccountTypeSchema,
  routing_number: routingNumberSchema,
  account_number: accountNumberSchema,
  remember: yup.boolean(),
  name: yup.string().max(32),
}

export const accountStepSchema =
  yup.object().shape(accountStep as unknown as Record<string, yup.Schema<unknown>>) as unknown as yup.ObjectSchema<AccountStepFields>

// Avoid TS2589 ("excessively deep") caused by yup's type inference over object spreads.
export const confirmationStepSchema = yup.object().shape({
  amount: amountStep.amount,
  bank_account_type: accountStep.bank_account_type,
  routing_number: accountStep.routing_number,
  account_number: accountStep.account_number,
  remember: accountStep.remember,
  name: accountStep.name,
} as unknown as Record<string, yup.Schema<unknown>>) as unknown as yup.ObjectSchema<ConfirmationStepFields>

// Default export uses confirmationStepSchema, because it includes all the fields
export default confirmationStepSchema
